
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/templates/[slug]",
      function () {
        return require("private-next-pages/site/templates/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/templates/[slug]"])
      });
    }
  